import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2 } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = '/api';

export default function BrandOfTheDay() {
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrand = async () => {
      try {
        const response = await axios.get(`${API}/brands/daily/brand-of-the-day`);
        setBrand(response.data.brand);
      } catch (error) {
        console.error("Brand fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBrand();
  }, []);

  if (loading) {
    return (
      <Card className="p-4 bg-gradient-to-br from-purple-500/10 to-purple-600/5 border-purple-500/20 animate-pulse">
        <div className="h-24"></div>
      </Card>
    );
  }

  if (!brand) return null;

  return (
    <Card className="p-4 bg-gradient-to-br from-purple-500/10 to-purple-600/5 border-purple-500/20 hover:border-purple-500/40 transition-all duration-300">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center flex-shrink-0">
          <Building2 className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-white truncate">Günün Markası</h3>
          <Badge className="bg-purple-500/80 text-white text-xs mt-1">{brand.sector}</Badge>
        </div>
      </div>
      
      <h4 className="text-lg font-bold text-purple-200 mb-1 truncate">{brand.name}</h4>
      <p className="text-white/70 text-xs line-clamp-2 mb-2">{brand.description}</p>
      
      {brand.achievement && (
        <p className="text-purple-100/80 text-xs italic line-clamp-1">
          🌟 {brand.achievement}
        </p>
      )}
    </Card>
  );
}
